import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { environment } from '../../../environments/environment';
import { iconList, isImage, isPdf } from '../constants';
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
declare var $: any;

@Component({
	selector: 'file-icon',
	templateUrl: './file-icon.component.html',
	styleUrl: './file-icon.component.scss'
})
export class FileIconComponent implements OnInit {
	File_Storage_URL = environment.File_Storage_URL;
	@Input() file: any = null;
	@Output() amountFetched = new EventEmitter<any>();
	file_name: any = "";
	fileUrl: any = null;
	isImage = false;
	isPdf = false;
	modalId: string = "";
	@ViewChild('modal', { static: true })
	modalTemplate!: TemplateRef<any>;
	private modalRef!: NgbModalRef;

	constructor(private modalService: NgbModal, private sanitizer: DomSanitizer, private toastr: ToastrService, private apiService: ApiService) { }

	ngOnInit(): void {
		this.file_name = this.getFileName();
		this.isPdf = isPdf(this.file_name);
		this.isImage = isImage(this.file_name);
		this.fileUrl = this.File_Storage_URL + this.file;
		let modalId = "filePreviewModal";
		try {
			modalId += this.file_name.split(".")[0];
		} catch (error) { }
		this.modalId = modalId;
	}

	getFileName() {
		try {
			return this.file.split("/").pop() || "";
		} catch (error) {
			return this.file;
		}
	}

	getFileExtension() {
		try {
			let ext = this.file.toLowerCase().split(".").pop();
			let obj = iconList.filter((row: any) => {
				if (row.type === ext) {
					return true;
				} else {
					return false;
				}
			});
			if (obj.length > 0) {
				let icon = obj[0].icon;
				return icon;
			} else {
				return "file";
			}
		} catch (error) {
			return "file";
		}
	}

	removeDomain() {
		try {
			return this.file.replace(/^https?:\/\/[^\/]+\//, "");
		} catch (error) {
			return this.file;
		}
	}

	openPreview() {
		this.modalRef = this.modalService.open(this.modalTemplate, {
			/* windowClass: 'right-modal' */
			size:"xl"
		});
	}

	getSafeUrl(url: any) {
		return this.sanitizer.bypassSecurityTrustResourceUrl(url)
	}

	copyLink() {
		let link = this.File_Storage_URL + this.file;
		navigator.clipboard.writeText(link).then(() => { }).catch(err => { });
		this.toastr.success("Link copied to clipboard", 'Copied', {
			timeOut: 3000,
			tapToDismiss: true,
			closeButton: true
		});
	}
}
